import React from 'react'
import { useEffect } from "react";
import Header from '../../components/Header'
import BasicTabs from '../../components/Tab'
import { useLoader } from '../../context/LoaderContext';


function PlansPricing() {
    const { startLoading, stopLoading } = useLoader();
    useEffect(() => {
      startLoading();
      setTimeout(() => {
        stopLoading();
      }, 1000);
    }, []);
    return (
        <>
            <div className="page-bg">
                <Header />
                <div className='container'>
                <div className='plane-page'>
                    <h1 className='text-center'>Plans & <span>Pricing</span></h1>
                    <p>Choose the therapy plan that is right for you! We offer excellent standard AI therapist services as well as a premium AI therapist trained on our unique dataset. Annual prices are approximately 33% off!</p>
                    <BasicTabs />
                </div>
               
                </div>

            </div>
        </>
    )
}

export default PlansPricing